import React from 'react';
import './Spinner.css'; // Import the spinner styles

const Spinner = () => {
  return (
    <div className="spinner-container">
      <div className="spinner"></div>
    </div>
  );
};

export default Spinner;
